import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { DEV_TOOL } from "src/main/contants";
import { DeployEnv } from "src/main/types";
import { getDeployEnv } from "src/main/utils";

const ILVDevTool = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // skip dev tool if in production
    if (getDeployEnv().deploymentType === DeployEnv.Production) {
      return;
    }

    // get deploy country from search params
    const deployCountry = searchParams.get(DEV_TOOL.SEARCH_PARAM.LOGIN_COUNTRY);
    if (deployCountry && deployCountry !== "null") {
      sessionStorage.setItem(DEV_TOOL.SESSION_STORAGE.LOGIN_COUNTRY, deployCountry);
    }

    // remove deploy country from session storage
    if (deployCountry === "null") {
      sessionStorage.removeItem(DEV_TOOL.SESSION_STORAGE.LOGIN_COUNTRY);
    }
  }, [searchParams]);

  return null;
};

ILVDevTool.propTypes = {};

export default ILVDevTool;
